import uuid from 'uuid';
import AssetTypeEnum from 'appConsts/AssetType';
import User from 'helper/currentUser';
import { CommandTypeEnum } from 'appConsts';
import mutationSync from '../../../../../graphql/helpers/mutationSync';
import { fetchRelayQueryForCourse } from '../../../learnerViewCards/utils/refetchAndSaveCourseData';

const user = new User();

const mutateAndGetPayload = params => new Promise(async (resolve) => {
  const { questionId, userId, rootOfferId: courseId, checkAnswersAttemptCount } = params;

  const command = {
    id: uuid(),
    creatorId: userId,
    timeStamp: new Date().toISOString(),
    type: CommandTypeEnum.CHECK_ANSWER,
    rootContentId: courseId,
    questionId,
    userId,
    checkAnswersAttemptCount
  };

  const { updatedStates } = await mutationSync({
    offerId: courseId,
    offerType: AssetTypeEnum.offer,
    userObject: {
      userId,
      companyId: user.companyId()
    },
    command
  });
  fetchRelayQueryForCourse(courseId, userId);
  resolve(updatedStates);
});

export default mutateAndGetPayload;
